"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("./base"));
var scrollbar_1 = tslib_1.__importDefault(require("./scrollbar"));
var slider_1 = tslib_1.__importDefault(require("./slider"));
base_1.default.registerInteraction('slider', slider_1.default);
base_1.default.registerInteraction('scrollbar', scrollbar_1.default);
tslib_1.__exportStar(require("./base"), exports);
exports.default = base_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/interaction/index.js
// module id = 868
// module chunks = 37